<template>
  <v-text-field
    v-model="model"
    :label="label"
    outlined
  />
</template>

<script>
export default {
  name: 'GenericTextField',
  props: {
    model: {
      type: String,
      default: 'N/A',
      required: false,
    },
    label: {
      type: String,
      default: 'N/A',
      required: false,
    },
  },
};
</script>

<style scoped>
</style>
